import React from "react";

import { CustomInput } from "./CustomInput";
import ColorSelectorPress from "./ColorSelectorPress";
import ImageSelector from "./ImageSelector";
import ThemeSelector from "./ThemeSelector";
import ToolTip from "../../../../parts/tooltip-portal";

export const PressStorefrontBrandingSection = ({
  active = false,
  handleChange,
  handleSwitch,
  state,
}) => {
  const {
    benefits,
    callLink,
    dayPassLink,
    formGymImg,
    formPressBannerImg,
    formPressPreviewImg,
    gymImg = {},
    gymImgChanged,
    gymName,
    pressBannerChanged,
    pressBannerImg,
    pressDescriptionSEO,
    pressFacebookLink,
    pressFavicon = {},
    pressFaviconChanged,
    pressFormFavicon = {},
    pressInstagramLink,
    pressPreviewImg,
    pressPreviewImgChanged,
    pressStorefrontMainColor,
    pressStorefrontSecondaryTextColor,
    pressStoreFrontTheme,
    pressTwitterLink,
    pressYoutubeLink,
  } = state;
  return (
    <div
      style={{
        display: active ? "block" : "none",
      }}
      className="storefront-section"
    >
      <article className="wrapper">
        <p className="s1">Storefront Setting</p>
        <section>
          <div className="left-column">
            <label>Storefront Theme</label>
            <ThemeSelector
              value={pressStoreFrontTheme}
              inputName="pressStoreFrontTheme"
              label="Storefront Theme"
              onChange={handleSwitch}
              isStorefront
              extraMargin
            />
            <ColorSelectorPress
              pressStorefrontMainColor={pressStorefrontMainColor}
              pressStorefrontSecondaryTextColor={
                pressStorefrontSecondaryTextColor
              }
              onChange={handleSwitch}
              onChangeColor={handleChange}
            />
          </div>
          <div className="right-column ">
            <img
              src={
                pressStoreFrontTheme === "dark"
                  ? "/img/press-storefront-dark.png"
                  : "/img/press-storefront-light.png"
              }
            />
          </div>
        </section>
      </article>
      <article className="wrapper">
        <p className="s1">Settings</p>
        <label>Gym Name</label>
        <input
          name="gymName"
          className="text-input w-[calc(50%-0.75rem)]"
          placeholder={`Enter gym name here..`}
          value={gymName}
          onChange={handleChange}
          sz="large"
        />
        <section>
          <div className="left-side">
            <header>
              <label>
                Book a call link{" "}
                <span className="label-explication">(e.g. calendly)</span>
              </label>
              <ToolTip
                body={[
                  "Enter a link to your scheduling software for someone to book a call in your calendar.",
                  <br />,
                  "For example, Calendly (this is optional).",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <CustomInput
              name="callLink"
              onChange={handleChange}
              value={callLink}
              placeholder="http://"
            />
          </div>
          <div className="right-side">
            <header>
              <label>Day Pass payment link</label>
              <ToolTip
                body={[
                  "Add any type of payment link for people to purchase a day pass",
                  <br />,
                  "(this is optional).",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <CustomInput
              name="dayPassLink"
              onChange={handleChange}
              value={dayPassLink}
              placeholder="http://"
            />
          </div>
        </section>
      </article>
      <article>
        <p className="s1">Content</p>
        <section>
          <div className="left-side">
            <header>
              <label>Description for SEO</label>
              <ToolTip
                body={[
                  "Add a short description of your gym to help with search engine optimization.",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <textarea
              name="pressDescriptionSEO"
              className="textarea-input"
              placeholder="My Description for SEO"
              value={pressDescriptionSEO}
              onChange={handleChange}
              maxLength={160}
              sz="large"
            />
          </div>
          <div className="right-side">
            <header>
              <label>Description / Benefits of Gym</label>
              <ToolTip
                body={[
                  "This is shown on the default gym membership website to describe your gym and highlight key membership benefits.",
                ]}
              >
                <img
                  className="help-icon"
                  src="/img/new-icons/question-circle.svg"
                />
              </ToolTip>
            </header>
            <textarea
              name="benefits"
              className="textarea-input"
              placeholder="My Description / Benefits of Gym"
              value={benefits}
              onChange={handleChange}
              maxLength={500}
              sz="large"
            />
          </div>
        </section>
      </article>
      <article className="wrapper social-wrapper">
        <p className="s1">Social Links</p>
        <section>
          <div className="left-side">
            <label>Instagram</label>
            <CustomInput
              name="pressInstagramLink"
              placeholder="https://mystrengthbook.com"
              value={pressInstagramLink}
              onChange={handleChange}
            />
            <label>Youtube</label>
            <CustomInput
              name="pressYoutubeLink"
              placeholder="https://mystrengthbook.com"
              value={pressYoutubeLink}
              onChange={handleChange}
            />
          </div>
          <div className="right-side">
            <label>Twitter</label>
            <CustomInput
              name="pressTwitterLink"
              placeholder="https://mystrengthbook.com"
              value={pressTwitterLink}
              onChange={handleChange}
            />
            <label>Facebook</label>
            <CustomInput
              name="pressFacebookLink"
              placeholder="https://mystrengthbook.com"
              value={pressFacebookLink}
              onChange={handleChange}
            />
          </div>
        </section>
      </article>
      <article className="wrapper images-wrapper">
        <p className="s1">Graphics</p>
        <section>
          <ImageSelector
            title="Banner"
            id="Press Banner"
            info="2560 x 423 Px"
            selectorTitle="Upload Banner"
            subInfo={
              <div>
                <span>JPG, GIF, SVG Or PNG.</span>
                <span>2560 x 423 px</span>
              </div>
            }
            buttonTitle="Edit Logo"
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="pressCustomBranding[pressBannerImg]"
            imageInputs={[
              { name: "pressBannerChanged", value: pressBannerChanged },
              {
                name: "formPressBannerImgFile",
                value: formPressBannerImg.file || "",
              },
              {
                name: "formPressBannerImgType",
                value: formPressBannerImg.type || "",
              },
              {
                name: "formPressBannerImgName",
                value: formPressBannerImg.name || "",
              },
              {
                name: "formPressBannerImgS3Path",
                value: formPressBannerImg.s3Path,
              },
            ]}
            value={pressBannerImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={"Required size:\n2560 x 423 Px"}
          />
          <ImageSelector
            title="Gym Image"
            id="Gym Image"
            info="1211 X 735 Px"
            selectorTitle="Upload Image"
            subInfo={
              <div>
                <span>JPG, GIF, SVG Or PNG.</span>
                <span>Max Size: 800kb</span>
              </div>
            }
            imageDimensions={{
              marginTop: 0,
            }}
            buttonTitle="Edit"
            inputName="pressCustomBranding[gymImg]"
            imageInputs={[
              { name: "gymImgChanged", value: gymImgChanged },
              { name: "formGymImgFile", value: formGymImg.file || "" },
              { name: "formGymImgType", value: formGymImg.type || "" },
              { name: "formGymImgName", value: formGymImg.name || "" },
              {
                name: "formGymImgS3Path",
                value: formGymImg.s3Path,
              },
            ]}
            value={gymImg}
            onChange={handleChange}
            showButton={false}
            toolTipTextBody={"Required size:\n1211 X 735 Px"}
          />
          <ImageSelector
            title="Custom Link Preview"
            id="Press Preview"
            info="1200 x 628 Px"
            selectorTitle="Upload Image"
            subInfo={
              <div>
                <span>JPG, GIF, Or PNG.</span>
                <span>Max Size: 800kb</span>
              </div>
            }
            buttonTitle="Edit"
            imageDimensions={{
              marginTop: 0,
            }}
            inputName="pressCustomBranding[pressPreviewImg]"
            imageInputs={[
              {
                name: "pressPreviewImgChanged",
                value: pressPreviewImgChanged,
              },
              {
                name: "formPressPreviewImgFile",
                value: formPressPreviewImg.file || "",
              },
              {
                name: "formPressPreviewImgType",
                value: formPressPreviewImg.type || "",
              },
              {
                name: "formPressPreviewImgName",
                value: formPressPreviewImg.name || "",
              },
              {
                name: "formPressPreviewImgS3Path",
                value: formPressPreviewImg.s3Path,
              },
            ]}
            value={pressPreviewImg}
            onChange={handleChange}
            allowedExtensions="image/jpeg,image/png"
            showButton={false}
            toolTipTextBody={"Required size:\n1200 x 628 Px"}
          />
          <ImageSelector
            title="Favicon"
            id="Press Favicon"
            selectorTitle="Upload Image"
            subInfo={
              <div>
                <span>JPG, GIF, SVG Or PNG.</span>
                <span>Max Size: 800kb</span>
              </div>
            }
            inputName="pressCustomBranding[pressFavicon]"
            imageInputs={[
              { name: "pressFaviconChanged", value: pressFaviconChanged },
              {
                name: "pressFormFaviconFile",
                value: pressFormFavicon.file || "",
              },
              {
                name: "pressFormFaviconType",
                value: pressFormFavicon.type || "",
              },
              {
                name: "pressFormFaviconName",
                value: pressFormFavicon.name || "",
              },
              {
                name: "pressFormFaviconS3Path",
                value: pressFormFavicon.s3Path,
              },
            ]}
            buttonTitle="Edit"
            value={pressFavicon}
            onChange={handleChange}
            imageDimensions={{
              marginTop: 0,
            }}
            showButton={false}
            toolTipTextBody={"Max Size: 800kb"}
          />
        </section>
      </article>
    </div>
  );
};
